import { render, staticRenderFns } from "./OrgGroupIndex.vue?vue&type=template&id=2753faff&scoped=true"
import script from "./OrgGroupIndex.vue?vue&type=script&lang=js"
export * from "./OrgGroupIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2753faff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2753faff')) {
      api.createRecord('2753faff', component.options)
    } else {
      api.reload('2753faff', component.options)
    }
    module.hot.accept("./OrgGroupIndex.vue?vue&type=template&id=2753faff&scoped=true", function () {
      api.rerender('2753faff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/org/OrgGroupIndex.vue"
export default component.exports